import { Image } from 'react-native';
import styled from 'styled-components/native';

export default styled(Image)`
  width: 119px;
  height: 40px;
`;
